import React, { useState, useEffect } from "react";
import { useDashboard } from "../../context/DashboardContext";
import CalendarDay from "./CalendarDay";
import Papa from "papaparse";

import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../register/firebase"; // path to your firebase.js
import axios from "axios";

import { getAuth } from "firebase/auth";

const ActivityCalendar = () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const { activityData } = useDashboard();

  const [data, setData] = useState([]);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const [dataMap, setDataMap] = useState({});

  // Generate last 12 months
  const months = Array.from({ length: 12 }, (_, i) => {
    const year = currentYear; // Always take the same year (unless you want to adjust manually)
    return {
      label: new Date(year, i).toLocaleString("default", { month: "short" }),
      year,
      monthIndex: i,
      firstDay: new Date(year, i, 1).getDay(),
      daysInMonth: new Date(year, i + 1, 0).getDate(),
    };
  });

  useEffect(() => {
    if (!user) {
      console.log("no user  found");
      return; // Safeguard: if no user, exit early
    } // Safeguard: if no user, exit early

    const fetchCSV = async () => {
      try {
        const uid = user.uid;
        const fileRef = ref(storage, `temp_csv/${uid}/trading_data_sample.csv`);
        const url = await getDownloadURL(fileRef);

        console.log("Download URL:", url);
        console.log("Starting to fetch CSV...");

        const response = await axios.get(url, { responseType: "text" });

        console.log("Fetch response status:", response.status);

        const csvText = response.data;
        console.log("CSV text fetched, starting to parse...");

        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            console.log("Parsing complete. Parsed data:", results.data);

            const parsedData = results.data;

            const map = {};
            parsedData.forEach((entry) => {
              // Normalize the date string as YYYY-MM-DD
              const dateObj = new Date(entry.date);
              const year = dateObj.getFullYear();
              const month = String(dateObj.getMonth() + 1).padStart(2, "0");
              const day = String(dateObj.getDate()).padStart(2, "0");

              const key = `${year}-${month}-${day}`;
              map[key] = entry; // O(1) lookup
            });
            console.log("Data map created:", map);
            // Set the state with the parsed data
            setData(parsedData); // (Optional: if you still want full array somewhere)
            setDataMap(map); // ✅ Save optimized map
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          },
        });
      } catch (error) {
        console.error("Error in fetching or parsing CSV:", error);
      }
    };

    fetchCSV();
  }, [user, storage]); // ✅ Dependency array

  // Group activity data by "YYYY-MM"
  const groupedData = {};
  data.forEach((day) => {
    const dateObj = new Date(day.Date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const key = `${year}-${month}`;
    if (!groupedData[key]) {
      groupedData[key] = [];
    }
    groupedData[key].push(day);
  });

  console.log(groupedData); // Check grouped data

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm overflow-x-auto">
      <div className="flex min-w-max gap-1 lg:gap-2">
        {months.map(({ label, year, monthIndex, firstDay, daysInMonth }) => {
          const key = `${year}-${String(monthIndex + 1).padStart(2, "0")}`;
          const monthData = groupedData[key] || [];

          return (
            <div
              key={`${label}-${year}`}
              className="flex flex-col min-w-[40px]"
            >
              <div className="grid grid-cols-7 gap-0.5 lg:gap-1">
                {/* Empty cells before the month starts */}
                {Array.from({ length: firstDay }, (_, i) => (
                  <div
                    key={`empty-start-${i}`}
                    className="w-3 h-3 sm:w-4 sm:h-4"
                  />
                ))}

                {/* Actual calendar days */}
                {Array.from({ length: daysInMonth }, (_, i) => {
                  const dateStr = new Date(
                    year,
                    monthIndex,
                    i + 1
                  ).toDateString();
                  const lookupKey = `${year}-${String(monthIndex + 1).padStart(
                    2,
                    "0"
                  )}-${String(i + 1).padStart(2, "0")}`;
                  const dayData = dataMap[lookupKey] || {
                    date: new Date(year, monthIndex, i + 1)
                      .toISOString()
                      .split("T")[0],
                    day_pnl: "0",
                    Status: "none",
                    pnl_range: "none",
                    current_streak: "0",
                    longest_streak: "0",
                    most_profit_day: "",
                    most_profit: "0",
                    total_fno_pnl: "0",
                    total_equity_pnl: "0",
                    today_fno_pnl: "0",
                    today_equity_pnl: "0",
                    total_pnl: "0",
                  };

                  return <CalendarDay key={`${key}-${i}`} data={dayData} />;
                })}

                {/* Empty cells after the month ends */}
                {Array.from(
                  { length: (7 - ((firstDay + daysInMonth) % 7)) % 7 },
                  (_, i) => (
                    <div
                      key={`empty-end-${i}`}
                      className="w-3 h-3 sm:w-4 sm:h-4"
                    />
                  )
                )}
              </div>
              <div className="text-xs text-gray-500 mt-1 text-center">
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityCalendar;
